import { Col, Form, Select } from "antd";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { SELECT_PROPS } from "../../../const/constant";
import { Claim } from "../../../types/RequestTypes";

function ARForm(props) {
  const { approver, endorser, device, claims, select_claim } = props;

  const draftClaim = (claims as Claim[]).find((i) => i.STATUS === "I");

  const getSelectValue = (list, empty = false) => {
    const r_list = [] as any;
    if (empty) {
      r_list.push({
        value: "",
        label: <div style={{ textAlign: "center" }}> - - -EMPTY- - - </div>,
      });
    }
    for (const app of list) {
      r_list.push({ value: app.NO, label: app.NA });
    }
    return r_list;
  };
  const approverList = getSelectValue(approver);
  const endorserList = getSelectValue(endorser, true);
  const emptyList = getSelectValue([], true);

  const filterOption = (input, option) => {
    if (typeof option.label !== "string") {
      return true;
    }
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  };

  return (
    <>
      {!_.isEmpty(endorserList) ? (
        <Col {...SELECT_PROPS[device.size]}>
          <Form.Item
            name={"Endorser"}
            label={"Endorser (Optional): "}
            initialValue={
              select_claim?.ENDORSER_STAFF_NO
                ? select_claim.ENDORSER_STAFF_NO
                : draftClaim?.ENDORSER_STAFF_NO
                ? draftClaim.ENDORSER_STAFF_NO
                : endorserList[0].value
            }
          >
            <Select
              showSearch
              options={endorserList}
              filterOption={filterOption}
            />
          </Form.Item>
        </Col>
      ) : (
        <Col {...SELECT_PROPS[device.size]}>
          <Form.Item
            name={"Endorser"}
            label={"Endorser (Optional): "}
            initialValue={emptyList[0].value}
          >
            <Select
              showSearch
              options={emptyList}
              filterOption={filterOption}
            />
          </Form.Item>
        </Col>
      )}
      {!_.isEmpty(approverList) ? (
        <Col {...SELECT_PROPS[device.size]}>
          <Form.Item
            name={"Approver"}
            label={"Approver: "}
            initialValue={
              select_claim?.APPROVER_STAFF_NO
                ? select_claim.APPROVER_STAFF_NO
                : draftClaim?.APPROVER_STAFF_NO
                ? draftClaim.APPROVER_STAFF_NO
                : approverList[0].value
            }
            rules={[{ required: true, message: "Please enter a approver." }]}
          >
            <Select
              showSearch
              options={approverList}
              filterOption={filterOption}
            />
          </Form.Item>
        </Col>
      ) : (
        <Col {...SELECT_PROPS[device.size]}>
          <Form.Item
            name={"Approver"}
            label={"Approver: "}
            initialValue={emptyList[0].value}
            // rules={[{ required: true, message: "Please enter a approver." }]}
          >
            <Select
              showSearch
              options={emptyList}
              filterOption={filterOption}
            />
          </Form.Item>
        </Col>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    approver: state.data.approver,
    endorser: state.data.endorser,
    device: state.session.device,
    claims: state.data.claims,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ARForm);
